<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF HOTEL MANAGEMENT & TOURISM</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">SYLLABUS</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12  col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Hotel Management & Catering Technology</td>
                        </tr>
                        <tr>
                            <td class="time">Bachelor of Science (Culinary Arts)</td>
                        </tr>
                        <tr>
                            <td class="time">Bachelor of Science (Hospitality & Culinary Management)</td>
                        </tr>
                        <tr>
                            <td class="time">Bachelor of Science (Hospitality & Hotel Administration)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center"> Hotel Management and Tourism</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Hotel Management & Catering
                    Technology </b>
                    – The four-year undergraduate Bachelor of Hotel Management & Catering Technology, or BHMCT,
                    curriculum at the ARNI School of Hotel Management & Tourism focuses on elucidating topics related to
                    hotel management, hospitality, and catering. Candidates are introduced to the concepts of management
                    and hospitality in this course.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 1</p>
                <ul>
                    <li> Food and Beverage – I</li>
                    <li> Food Production - I</li>
                    <li> Housekeeping Operations - I</li>
                    <li> Catering Science- I</li>
                    <li> Kitchen Operations Management- I</li>
                    <li> Accommodation Fundamentals</li>
                    <li> Business Communication skills</li>
                    <li> Human Resource Management</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 2</p>
                <ul>
                    <li> Food and Beverage Service- II</li>
                    <li> Food Production-II</li>
                    <li> Kitchen Operations II</li>
                    <li> Housekeeping Operations- II</li>
                    <li> Catering Science-II</li>
                    <li> Marketing Management</li>
                    <li> Front Office Management</li>
                    <li> Introduction to Beer, Spirits and Liqueurs</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 3</p>
                <ul>
                    <li> Food and Beverage Service- III</li>
                    <li> Food Production-III</li>
                    <li> Computer Fundamentals</li>
                    <li> Environmental Studies</li>
                    <li> Basic Billing & Accounting</li>
                    <li> International HMM</li>
                    <li> Industrial Training</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 4</p>
                <ul>
                    <li> Food and Beverage Service- IV</li>
                    <li> Food Production-IV</li>
                    <li> Accommodation Operations -I</li>
                    <li> Traditional Patisserie</li>
                    <li> Hospitality Finance- I</li>
                    <li> Wine Fundamentals</li>
                    <li> Hotel Engineering</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 5</p>
                <ul>
                    <li> Hospitality Finance - II</li>
                    <li> Culinary Practice</li>
                    <li> Food Science and Nutrition</li>
                    <li> Mandatory Industrial Training</li>
                    <li> Hotel economics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 6</p>
                <ul>
                    <li> Sales and Management -I</li>
                    <li> Strategic Management</li>
                    <li> Advanced Food Production</li>
                    <li> Advanced Food and Beverage Service</li>
                    <li> Business Communication and Personality Development</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 7</p>
                <ul>
                    <li> Sales and Marketing -II</li>
                    <li> Hotel Information Systems</li>
                    <li> Business Management & Entrepreneurship</li>
                    <li> Hotel-related laws</li>
                    <li> Banquet Management & Bar Operations</li>
                    <li> Quality Management</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 8</p>
                <ul>
                    <li> Event Planning, Convention, and Operation</li>
                    <li> Hotel Facilities Planning</li>
                    <li> Total Quality Management</li>
                    <li> Advanced Patisserie</li>
                    <li> Elective I</li>
                    <li> Research Project</li>
                    <li> Internship/ Viva</li>

                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science (Culinary Arts)</b>
                    – The three-year undergraduate Bachelor of Science (BSc) in Culinary Arts, curriculum at the ARNI
                    School of Hotel Management & Tourism focuses on cooking and baking techniques, food presentation,
                    and other culinary sciences. It also covers the business and management side of the culinary
                    industry.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 1</p>
                <ul>
                    <li> Foundation & Principle of Culinary Arts (Theory I)</li>
                    <li> Foundation & Principle of Bakery and Pastry Arts (Theory I)</li>
                    <li> Communication Skills</li>
                    <li> Safety & Hygiene Health</li>
                    <li> French Culinary - I</li>
                    <li> Fundamentals of Food and Beverage Service</li>
                    <li> Foundation & Principle of Culinary Arts (Practical)</li>
                    <li> Foundation & Principle of Bakery and Pastry Arts (Practical)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 2</p>
                <ul>
                    <li> Indian Cuisine - Food Production Operations (Theory)</li>
                    <li> Basic Introduction to Nutrition</li>
                    <li> Computer Application</li>
                    <li> Personality Development</li>
                    <li> Introduction Course in Beverage</li>
                    <li> Gastronomic Tourism</li>
                    <li> Report Writing</li>
                    <li> Indian Cuisine - Food Production Operations (Practical)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 3</p>
                <ul>
                    <li> Foundation & Principle of Culinary Arts (Theory II)</li>
                    <li> Foundation & Principle of Bakery and Pastry Arts (Theory II)</li>
                    <li> Global Cuisine and Gastronomy</li>
                    <li> Computer Applications in Food Production</li>
                    <li> Banquet Management & Quantity Production</li>
                    <li> Foundation & Principle of Culinary Arts (Practical II)</li>
                    <li> Foundation & Principle of Bakery and Pastry Arts (Practical II)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 4</p>
                <ul>
                    <li> Material Management & Menu Function</li>
                    <li> Indian Culture and Cuisine</li>
                    <li> Financial Accounting in Hospitality</li>
                    <li> Carving and sculpturing skills</li>
                    <li> Fundamentals of Entrepreneurship</li>
                    <li> Consumer Behavior and Interview Skills</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 5</p>
                <ul>
                    <li> Food Engineering</li>
                    <li> Food Prevention and Processing</li>
                    <li> Advanced Culinary Practical</li>
                    <li> Environmental Studies</li>
                    <li> Management for Chefs</li>
                    <li> Seminar and Professional Training</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BHMCT</b> : Semester 6</p>
                <ul>
                    <li> Ice Cream and Chocolate Manufacturing</li>
                    <li> International Cuisines – Kitchen Management</li>
                    <li> Introduction to Food Science</li>
                    <li> Cruise Catering</li>
                    <li> Event Management</li>
                    <li> Food and Wine Pairing</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science in Hospitality & Culinary
                    Management</b>
                    – The B.Sc. in Hospitality & Culinary Management at ARNI School of Hotel Management & Tourism is
                    designed to provide students with a strong foundation in hospitality operations, food production,
                    customer service, and business management. The 3-year curriculum is divided into six semesters with
                    a mix of core subjects, elective specializations, hands-on training, internships, and industry
                    projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Introduction</p>
                <ul>
                    <li> Introduction to Hospitality & Tourism Industry</li>
                    <li> Fundamentals of Food Production & Culinary Arts</li>
                    <li> Food & Beverage Service Operations</li>
                    <li> Front Office Management & Guest Handling</li>
                    <li> Communication & Soft Skills Development</li>
                    <li> Hygiene & Sanitation in Hospitality</li>
                    <li> Practical Training in Food Production & Service</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Operational Management</p>
                <ul>
                    <li> Hospitality Business Management</li>
                    <li> Advanced Culinary Techniques</li>
                    <li> Housekeeping & Facility Management</li>
                    <li> Principles of Nutrition & Dietetics</li>
                    <li> Bakery & Confectionery</li>
                    <li> Food Science & Safety Regulations</li>
                    <li> Practical Sessions in Bakery & Housekeeping</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Culinary Excellence</p>
                <ul>
                    <li> International Cuisine & Gastronomy</li>
                    <li> Restaurant & Banquet Management</li>
                    <li> Hotel Accounting & Financial Management</li>
                    <li> Digital Marketing & Branding in Hospitality</li>
                    <li> Wines, Spirits & Beverage Studies</li>
                    <li> Hospitality Law & Ethics</li>
                    <li> Practical Training in International Cuisines</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Advanced Hospitality</p>
                <ul>
                    <li> Entrepreneurship & Business Development in Hospitality</li>
                    <li> Resort & Event Management</li>
                    <li> Travel & Tourism Operations</li>
                    <li> Customer Relationship Management</li>
                    <li> Research Methodology in Hospitality</li>
                    <li> Elective-I (Luxury Hospitality, Cruise Management, or Airline Catering)</li>
                    <li> Internship in Hotels/Restaurants</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b>: Specialization</p>
                <ul>
                    <li> Menu Planning & Cost Control</li>
                    <li> Hotel & Resort Planning</li>
                    <li> Strategic Management in Hospitality</li>
                    <li> Sustainable Tourism & Eco-Hospitality</li>
                    <li> Hospitality Technology & Software Training</li>
                    <li> Elective-II (Food Photography & Styling, Resort Management, or Spa & Wellness)</li>
                    <li> Industrial Training in Hotels/Resorts</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b>: Project & Career Readiness</p>
                <ul>
                    <li> Leadership & Human Resource Management in Hospitality</li>
                    <li> Advanced Culinary Research & Innovation</li>
                    <li> Major Project in Hospitality & Culinary Management</li>
                    <li> Internship/Industrial Exposure Training</li>
                    <li> Seminar & Viva Voce</li>
                </ul>
            </div>


            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science (Hospitality & Hotel
                    Administration)</b>
                    – The ARNI School of Hotel Management & Tourism's B.Sc. in Hospitality & Hotel Administration
                    program is created to give students the abilities, know-how, and mindset they need to effectively
                    carry out supervisory duties in the hospitality industry. With a combination of foundational
                    courses, elective specialties, practical instruction, internships, and industrial projects, the
                    three-year program is broken up into six semesters.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>: Foundation</p>
                <ul>
                    <li> Foundation Course in Accommodation Operations I</li>
                    <li> Foundation Course in Food Production I</li>
                    <li> Foundation Course in Food & Beverage Service I</li>
                    <li> Foundation Course in Front Office</li>
                    <li> Application of Computers</li>
                    <li> Communication Skills</li>
                    <li> Hotel-Engineering Nutrition</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>: Core Concepts</p>
                <ul>
                    <li> Foundation Course in Food Production - I</li>
                    <li> Foundation Course in Accommodation Operations Il</li>
                    <li> Foundation Course in Food & Beverage Service II</li>
                    <li> Foundation Course in Front Office II</li>
                    <li> Principles of Food Science</li>
                    <li> Accountancy</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>: Operational Concepts</p>
                <ul>
                    <li> Accommodation Operations</li>
                    <li> Food Production Operations</li>
                    <li> Front Office Operations</li>
                    <li> Food & Beverage Operations</li>
                    <li> Food & Beverage Controls</li>
                    <li> Hotel Accountancy</li>
                    <li> Food Safety & Quality</li>
                    <li> Research Methodology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>: Industry Experience</p>
                <ul>
                    <li> Human Resource Management</li>
                    <li> Hotel accountancy</li>
                    <li> Project</li>
                    <li> Internship</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b>: Management</p>
                <ul>
                    <li> Advance Food Production Operations - I</li>
                    <li> Front Office Management - I</li>
                    <li> Advance Food & Beverage Operations - I</li>
                    <li> Accommodation Management - I</li>
                    <li> Financial Management</li>
                    <li> Strategic Management</li>
                    <li> Research Project</li>
                    <li> Special topics/Guest speakers</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b>: Project and Assignment</p>
                <ul>
                    <li> Advance Food Production Operations - II</li>
                    <li> Advance F&B Operations - II</li>
                    <li> Front Office Management - II</li>
                    <li> Accommodation Management - II</li>
                    <li> Food & Beverage Management</li>
                    <li> Facility Planning</li>
                    <li> Research Project</li>
                    <li> Special topics/Guest speakers</li>
                </ul>
            </div>

        </div>

    </div>
</section>
